// extracted by mini-css-extract-plugin
module.exports = {"container":"Song_container__37JYo"};